/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Reasons_Allocationamounttoosmall5Inputs */

const en_coinvestments_declinedeal_reasons_allocationamounttoosmall5 = /** @type {(inputs: Coinvestments_Declinedeal_Reasons_Allocationamounttoosmall5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation amount too small`)
};

/**
* | output |
* | --- |
* | "Allocation amount too small" |
*
* @param {Coinvestments_Declinedeal_Reasons_Allocationamounttoosmall5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_reasons_allocationamounttoosmall5 = /** @type {((inputs?: Coinvestments_Declinedeal_Reasons_Allocationamounttoosmall5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Reasons_Allocationamounttoosmall5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_reasons_allocationamounttoosmall5(inputs)
});
export { coinvestments_declinedeal_reasons_allocationamounttoosmall5 as "coInvestments_declineDeal_reasons_allocationAmountTooSmall" }